export interface RefreshQrCodeIconProps {
  className?: string;
}

export function RefreshQrCodeIcon({ className }: RefreshQrCodeIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <rect
        width="5"
        height="5"
        x="3"
        y="3"
        rx="1"
        fill="none"
        stroke="currentColor"
      />
      <rect
        width="5"
        height="5"
        x="16"
        y="3"
        rx="1"
        fill="none"
        stroke="currentColor"
      />
      <rect
        width="5"
        height="5"
        x="3"
        y="16"
        rx="1"
        fill="none"
        stroke="currentColor"
      />
      <path d="M12 7v3a2 2 0 0 1-2 2H7" stroke="currentColor" />
      <path d="M3 12h.01" stroke="currentColor" />
      <path d="M12 3h.01" stroke="currentColor" />
      <g
        transform="translate(12, 12) scale(0.5)"
        strokeWidth="4"
        stroke="currentColor"
      >
        <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
        <path d="M3 3v5h5" />
      </g>
    </svg>
  );
}
